import { favoritesApiBaseUrl } from '../../appConfig';
import BaseService from '../BaseService';

const unwrapGwPayload = body => {
  if (!body || typeof body !== 'object') {
    return body;
  }

  if ('success' in body && body.success === false) {
    return null;
  }

  if ('success' in body && 'data' in body) {
    return body.data;
  }

  return body;
};

const validateStatus = status => status >= 200 && status < 500 && status !== 401;

const toResult = response => ({
  status: response?.status,
  data: unwrapGwPayload(response?.data)
});

class FavoritesService {
  getFavoriteSkus = () => {
    return BaseService.get(`${favoritesApiBaseUrl}/favorite-skus`, { validateStatus }).then(
      toResult
    );
  };

  addFavorite = ({ sku, listingId, productId }) => {
    return BaseService.post(
      `${favoritesApiBaseUrl}/favorites`,
      { sku, listingId, productId },
      { validateStatus }
    ).then(toResult);
  };

  removeFavorite = sku => {
    return BaseService.delete(`${favoritesApiBaseUrl}/favorites/${encodeURIComponent(sku)}`, {
      validateStatus
    }).then(toResult);
  };
}

export default new FavoritesService();
